import { useEffect, useState } from 'react';

// mui
import { Grid, ListItem, Stack, ListItemButton, Typography } from '@mui/material';

// api
import { def } from '@goldblack/shared';

// component
import { pushNavigation, createProfileProp } from '../../';

// client-shared
import { UserAvatar, UserBadges } from '@goldblack/client-comps';

function UserListItem(props) {
    const [avatarLoading, setAvatarLoading] = useState(() =>
        Boolean(props.user?.thumbnail || props.user?.image),
    );
    const hasImage = Boolean(props.user?.thumbnail || props.user?.image);

    const onClickItem = (e) => {
        switch (e.detail) {
            case 1:
                break;
            case 2:
                // double click
                break;
            default:
                break;
        }
    };

    const onClickAvatar = () => {
        pushNavigation(createProfileProp(props.user));
    };

    const onAvatarLoad = () => {
        setAvatarLoading(false);
    };

    const createSelected = () => {
        return props.selected
            ? props.selected
            : props.path === 'home' && props.user.button === def.UserButtonState.CHAT;
    };

    useEffect(() => {
        setAvatarLoading(hasImage);
    }, [hasImage]);

    return (
        <ListItem disablePadding>
            <ListItemButton onClick={props.onClick ? props.onClick : onClickItem} selected={createSelected()}>
                {props.user.rank !== undefined && (
                    <Typography color='primary.light' variant='body1' sx={{ width: '60px' }}>
                        {props.user.rank}
                    </Typography>
                )}
                {/*===== avatar =====*/}
                <UserAvatar
                    loding={avatarLoading}
                    variant={props.type}
                    user={props.user}
                    config={props.config}
                    onLoad={onAvatarLoad}
                    onClick={onClickAvatar}
                />
                <Grid
                    container
                    spacing={0}
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                    sx={{ ml: 2, p: 0 }}>
                    <Grid container direction='column' justifyContent='flex-start'>
                        <Stack direction='row' justifyItems='flex-start' alignItems='center' gap={0}>
                            <Typography variant='body1' noWrap color='primary.main'>
                                {props.user.username}
                            </Typography>
                            <UserBadges badge={props.user.badge} />
                        </Stack>
                        <Typography color='secondary.main' variant='body2' noWrap maxWidth='200px'>
                            {props.user.name}
                        </Typography>
                    </Grid>
                </Grid>
            </ListItemButton>
        </ListItem>
    );
}

export { UserListItem };
